
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"60","height":"60","viewBox":"0 0 60 60","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M26.854 36.935c-1.16 6.027-2.56 11.802-6.734 14.816-1.293-9.107 1.893-15.945 3.373-23.194-2.52-4.221.307-12.718 5.614-10.62 6.533 2.575-5.654 15.692 2.52 17.325 8.546 1.713 12.04-14.763 6.733-20.127-7.653-7.74-22.293-.172-20.493 10.9.44 2.708 3.253 3.531 1.12 7.262-4.907-1.075-6.36-4.925-6.173-10.063.306-8.404 7.573-14.286 14.88-15.096 9.226-1.022 17.893 3.373 19.093 12.016 1.346 9.758-4.16 20.326-14.04 19.569-2.667-.2-3.787-1.514-5.893-2.788z"}}),_c('path',{attrs:{"d":"M30 59.744c-16.547 0-30-13.396-30-29.872S13.453 0 30 0s30 13.396 30 29.872-13.467 29.872-30 29.872zm0-57.089c-15.067 0-27.333 12.215-27.333 27.217 0 15.002 12.266 27.216 27.333 27.216 15.067 0 27.333-12.214 27.333-27.216S45.067 2.655 30 2.655z"}})])
          )
        }
      }
    